import React from 'react';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import FolderVideos from '../../features/Folder/components/FolderVideos/FolderVideos';

export default function Folder({ folderId }) {
  return (
    <>
      <ProtectedPageSidebar />
      <FolderVideos folderId={folderId} />
    </>
  );
}
